import React from "react";

interface CodeTextIconProps extends React.SVGProps<SVGSVGElement> {
  size?: string;
}

export const CodeTextIcon: React.FC<CodeTextIconProps> = ({
  size,
  color,
  ...svgProps
}) => {
  return (
    <svg
      width={size ?? "32px"}
      height={size ?? "32px"}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...svgProps}
    >
      <path
        d="M18.3072 5.62939L13.6924 26.3701"
        stroke={color ?? "#667085"}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M23.7778 10.8149L28.963 16.0001L23.7778 21.1853"
        stroke={color ?? "#667085"}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.22181 21.1853L3.03662 16.0001L8.22181 10.8149"
        stroke={color ?? "#667085"}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
